<!-- 
共通の確認ダイアログ（OK、キャンセル）を表示するモジュール
@props
  enableOkButton OKボタンが押下可能であればtrueを設定する
  autoClose OKボタンを押下した時に必ず閉じるのであればtrue、処理完了後に判定して、hideDialogメソッドを呼ぶ必要があればfalseを指定する
@event
  on-click-ok : OKボタンクリック時のコールバックイベント
@slot
  ダイアログに表示するメッセージ
-->

<template>
  <v-fade-transition>
    <v-overlay v-show="dialog" light :dark="false">
      <dialog-base title="確認" elevation="12">
        <v-card-text><slot></slot></v-card-text>
        <v-card-actions>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn color="primary" text class="mr-2" @click="hideDialog">
                キャンセル
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="receivedOk"
                :disabled="!enableOkButton"
              >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </dialog-base>
    </v-overlay>
  </v-fade-transition>
</template>

<script>
import DialogBase from "../frame/dialog-base.vue";
export default {
  components: {
    "dialog-base": DialogBase,
  },
  props: {
    enableOkButton: {
      type: Boolean,
      default: true,
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    /**
     * ダイアログを表示する
     */
    showDialog() {
      this.dialog = true;
    },
    /**
     * ダイアログを閉じる
     */
    hideDialog() {
      this.dialog = false;
    },
    /**
     * OKボタンが押下された
     */
    receivedOk() {
      this.$emit("on-click-ok");
      if (this.autoClose) {
        this.hideDialog();
      }
    },
  },
};
</script>

<style></style>
